// Components
import TextRenderer from '../../CellRenderers/TextRenderer';

// Containers
import makeCellRenderer from '../containers/makeCellRenderer';
var TextDisplayCellRenderer = makeCellRenderer(TextRenderer);
export default TextDisplayCellRenderer;